import { Flex, SetLogo, SetLogoSmall, styled } from '@shared/components';
import { Link } from 'react-router-dom';

const LogoWithBackdrop = styled(Flex)(({ theme }) => ({
  position: 'sticky',
  alignItems: 'center',
  flexShrink: 0,
  top: 0,
  backgroundColor: theme.palette.background.paper,
  borderBottom: '1px solid',
  borderColor: theme.palette.grey[300],
  zIndex: 100,
  justifyContent: 'center',
  padding: theme.spacing(2.5),
  height: 80,
}));

interface SidebarLogoProps {
  minified?: boolean;
}

function SidebarLogo(props: Readonly<SidebarLogoProps>) {
  const { minified: isMinified } = props;
  return (
    <Link to='/'>
      <LogoWithBackdrop>
        {/* no unmounting images for smoother animation */}
        <SetLogo sx={{ height: '32px', width: 'auto', display: isMinified ? 'none' : 'block' }} />
        <SetLogoSmall
          sx={{ height: '32px', width: '32px', display: isMinified ? 'block' : 'none' }}
        />
      </LogoWithBackdrop>
    </Link>
  );
}

export default SidebarLogo;
